import anime from 'animejs/lib/anime.es.js';
import 'external-svg-loader';

document.addEventListener("DOMContentLoaded", function() {

    /**
     * Anime.js Integration for SVG Animations
     *
     * https://github.com/juliangarnier/anime
     */

    SVGLoader.destroyCache();

    let animatedsvgs = document.querySelectorAll('.icon-image');

    Array.from(animatedsvgs).forEach(function(entry, index) {
        setTimeout(function(){
            entry.style.opacity = 1;
            let animation = anime.timeline({
                easing: 'easeInOutSine',
                duration: 1000,

                delay: function(el, i) {
                    return i * 50;
                },
            });

            let autohaus = entry.querySelectorAll('.st0');
                autohaus.forEach(function(p) { p.style.fill = '#8e7d71' });

            animation.add({
                targets: autohaus,
                opacity: [0, 1],
            });

            let dobersberg = entry.querySelectorAll('.st1');
            dobersberg.forEach(function(c) { c.style.fill = '#FFFFFF' });

            animation.add({
                targets: dobersberg,
                opacity: [0, 1],
            }, '-=500');


        }, 250);
    });

});
